import merge from 'webpack-merge'
import baseConfig from './config.base'

const config = {
  hosts: {
    resource: 'https://air.mansitu.cn/',
    request: 'https://air.mansitu.cn/api/'
  },
  apis: {
    session: 'open/getcurrent'
  }
}

export default merge(baseConfig, config)



// WEBPACK FOOTER //
// ./src/config/config.prod.js